import React from 'react'

const JoinUs = () => {
  return (
    <div>JoinUs</div>
  )
}

export default JoinUs